/**
 * Return command for a keyboard event
 *
 * @param {SyntheticKeyboardEvent} event
 * @return {String}
 */
function getKeyBinding(e) {}

module.exports = getKeyBinding;



//////////////////
// WEBPACK FOOTER
// ./~/draft-js-code/lib/getKeyBinding.js
// module id = 922
// module chunks = 0